var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.868,
    height: 6.691,
    viewBox: "0 0 6.868 6.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-checkmark",
    d: "M9.2,3.39a.378.378,0,0,0-.523.1L5.63,7.984l-1.4-1.4a.378.378,0,0,0-.532,0l-.532.533a.376.376,0,0,0,0,.532L5.319,9.8a.734.734,0,0,0,.481.213.578.578,0,0,0,.453-.268l3.67-5.413Z",
    transform: "translate(-3.055 -3.325)",
    fill: "#b5b5b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGrey);
export default __webpack_public_path__ + "static/media/tick-grey.c7ca794dbde69b4e08ef20d87c0cea36.svg";
export { ForwardRef as ReactComponent };